import { SlateProps } from './component';
import { SlateApi } from './api';

export type SlateControlsProps = SlateProps & Partial<SlateApi>;
